import type { CommitmentMatrixDashboardCollaboratorStatus } from '@/types'

export const STATUS_PILL_CLASS: Record<
	CommitmentMatrixDashboardCollaboratorStatus,
	string
> = {
	on_track: 'bg-kaefer-grass-green/15 text-kaefer-forest-green',
	in_progress: 'bg-kaefer-honey-yellow/20 text-kaefer-dark-grey',
	not_started: 'bg-kaefer-red/15 text-kaefer-red',
	aboned: 'bg-kaefer-sapphire-blue/15 text-kaefer-sapphire-blue',
}

export const STATUS_LABEL: Record<
	CommitmentMatrixDashboardCollaboratorStatus,
	string
> = {
	on_track: 'Concluido',
	in_progress: 'Em andamento',
	not_started: 'Não iniciado',
	aboned: 'Abonado',
}

export function pillClassForPct(pct: number): string {
	if (pct >= 100) return 'bg-kaefer-grass-green/15 text-kaefer-forest-green'
	if (pct >= 50) return 'bg-kaefer-honey-yellow/20 text-kaefer-dark-grey'
	return 'bg-kaefer-red/15 text-kaefer-red'
}
